import type { SVGProps } from 'react';

const SvgLaptopWindows = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M20 18v-1h1.99L22 3H2v14h2v1H0v2h24v-2zM4 5h16v10H4z" />
  </svg>
);
export default SvgLaptopWindows;
